import { FE_ENABLE_REACT_SCAN_MONITORING_250107 } from "@faire/retailer-settings/FE_ENABLE_REACT_SCAN_MONITORING_250107";
import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
export var useSettingEnableReactScanMonitoring = function() {
    return useSetting(FE_ENABLE_REACT_SCAN_MONITORING_250107);
};
